<template>
  <el-card>
    <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
      <span>协议管理</span>
      <el-button type="primary" size="small" @click="handleAdd">新增协议</el-button>
    </div>

    <el-table :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="agreementType" label="协议类型" width="150">
        <template slot-scope="scope">
          {{ getTypeName(scope.row.agreementType) }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="version" label="版本" width="100" />
      <el-table-column prop="isActive" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive ? 'success' : 'info'">
            {{ scope.row.isActive ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="800px"
      :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="协议类型" prop="agreementType">
          <el-select v-model="form.agreementType" placeholder="请选择协议类型" style="width: 100%;">
            <el-option label="用户协议" value="user_agreement" />
            <el-option label="隐私政策" value="privacy_policy" />
          </el-select>
        </el-form-item>
        <el-form-item label="协议标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入协议标题" />
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="form.version" placeholder="例如: 1.0.0" />
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-switch v-model="form.isActive" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="协议内容" prop="content">
          <el-input 
            v-model="form.content" 
            type="textarea" 
            :rows="15"
            placeholder="请输入协议内容，支持 Markdown 格式"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="saving">保存</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import request from '@/utils/request'

export default {
  data () {
    return {
      rows: [],
      dialogVisible: false,
      dialogTitle: '',
      saving: false,
      form: {
        agreementType: '',
        title: '',
        content: '',
        version: '1.0.0',
        isActive: 1
      },
      rules: {
        agreementType: [{ required: true, message: '请选择协议类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入协议标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入协议内容', trigger: 'blur' }]
      },
      editingId: null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      try {
        const res = await request.get('/admin/agreements')
        this.rows = res.data || []
      } catch (error) {
        this.$message.error('加载失败：' + error.message)
      }
    },
    getTypeName (type) {
      const map = {
        user_agreement: '用户协议',
        privacy_policy: '隐私政策'
      }
      return map[type] || type
    },
    handleAdd () {
      this.dialogTitle = '新增协议'
      this.editingId = null
      this.form = {
        agreementType: '',
        title: '',
        content: '',
        version: '1.0.0',
        isActive: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit (row) {
      this.dialogTitle = '编辑协议'
      this.editingId = row.id
      this.form = {
        agreementType: row.agreementType,
        title: row.title,
        content: row.content,
        version: row.version,
        isActive: row.isActive
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        this.saving = true
        try {
          if (this.editingId) {
            await request.put(`/admin/agreements/${this.editingId}`, this.form)
            this.$message.success('更新成功')
          } else {
            await request.post('/admin/agreements', this.form)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          await this.loadData()
        } catch (error) {
          this.$message.error('保存失败：' + error.message)
        } finally {
          this.saving = false
        }
      })
    },
    handleDelete (row) {
      this.$confirm('确定要删除这个协议吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await request.delete(`/admin/agreements/${row.id}`)
          this.$message.success('删除成功')
          await this.loadData()
        } catch (error) {
          this.$message.error('删除失败：' + error.message)
        }
      }).catch(() => {})
    }
  }
}
</script>
